import React, { useEffect } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Box, Button, Grid } from '@material-ui/core';
import { connect } from "react-redux";
import { ApplicationState } from "../../redux/reducers";
import { IUsuario } from "../../entities/catalogos/IUsuario";
import { useHistory } from "react-router-dom";
import { traducirButton, traducirLabel } from "../../blocks/traductor";
import StepGuia, { IStepGuia } from "../stepper/StepGuia";
import { IGuiaWizard } from "../../entities/guias/IGuiaWizard";
import { IParametro } from "../../redux/types/parametroActionTypes";
import { loadParametros } from "../../redux/actions/parametroActions";
import { loadTiposSeguroObservacion } from "../../redux/actions/tipoSeguroObservacionActions";
import { ICatalogo } from "../../entities/catalogos/ICatalogo";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            flexGrow: 1,
        },
        header: {
            width: "100%",
            height: '48px',
            background: "transparent",
            boxShadow: "none"
        },
        toolbar: {
            minHeight: '48px'
        },
        back: {
            backgroundColor: "transparent"
        },
        buttonBack: {
            color: "#19754e",
            fontWeight: 600,
            fontSize: "16px"
        }
    }),
);

interface StateProps {
    usuario: IUsuario;
    parametros: IParametro[];
    tiposSeguroObservacion: ICatalogo[];
    guiaWizard: IGuiaWizard;
}

interface DispatchProps {
    loadParametros: typeof loadParametros;
    loadTiposSeguroObservacion: typeof loadTiposSeguroObservacion;
}

type Props = StateProps & DispatchProps & {
    ocultarStepper?: boolean;
    onVolver?: () => void;
};

const HeaderGuia = (props: Props) => {
    const classes = useStyles();
    const history = useHistory();
    const mostrarStepper = !props.guiaWizard.createResult && !props.ocultarStepper;
    const mostrarRegreso = !props.guiaWizard.createResult || !!props.ocultarStepper;

    useEffect(() => {
        if (props.parametros?.length === 0) {
            props.loadParametros();
        }
        if (props.tiposSeguroObservacion?.length === 0) {
            props.loadTiposSeguroObservacion();
        }
    }, []);

    const pasos: IStepGuia[] = [
        { id: 1, nombre: traducirLabel(223), editable: true },
        { id: 2, nombre: traducirLabel(71), editable: true },
        { id: 3, nombre: traducirLabel(278), editable: true },
        { id: 4, nombre: traducirLabel(264), editable: false },
        { id: 5, nombre: traducirLabel(357), esUltimoPaso: true, editable: false }
    ];

    return (<>
        <div className="step-section" style={{ height: 'auto' }}>
            <AppBar position="static" color="transparent" elevation={0} className={classes.header}>
                <Toolbar className={classes.toolbar}>
                    <div className={classes.title}>
                        <img src="/image/almex-logo.png" alt={""} />
                    </div>
                    <Breadcrumbs separator="|" aria-label="breadcrumb">
                        <Typography color="textPrimary">
                            {traducirLabel(20)}, <b>{props.usuario.nombre}</b>
                        </Typography>
                        <Button onClick={() => history.push("/")}>
                            {traducirButton(11)}
                        </Button>
                    </Breadcrumbs>
                </Toolbar>
            </AppBar>
            {mostrarStepper &&
                <Grid container justify="center" alignItems="center" style={{ minHeight: 150 }}>
                    {pasos.map((paso) => (
                        <StepGuia
                            key={paso.id}
                            id={paso.id}
                            nombre={paso.nombre}
                            esUltimoPaso={paso.esUltimoPaso}
                            editable={paso.editable}
                        />
                    ))}
                </Grid>
            }
        </div>
        {mostrarRegreso &&
            <Grid container className={classes.back}>
                <Grid item sm={12}>
                    <Box display="flex" justifyContent="flex-end">
                        <Button className={classes.buttonBack} onClick={() => props.onVolver ? props.onVolver() : history.push("/")}>
                            {traducirButton(9)}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        }
    </>);
};

const mapStateToProps = (state: ApplicationState) => ({
    usuario: state.usuario,
    parametros: state.parametros,
    tiposSeguroObservacion: state.tiposSeguroObservacion,
    guiaWizard: state.guiaWizard
});

const mapDispatchToProps = {
    loadParametros,
    loadTiposSeguroObservacion
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderGuia);
